import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./share.html";
class Share extends LightningElement {
  constructor(...args) {
    super(...args);
    this.url = void 0;
    this.title = void 0;
    this.wrapperClass = void 0;
    this.tooltip = void 0;
  }
  /**
   * Ensure we have a valid URL.
   */
  get hasUrl() {
    return this.url?.length && URL.canParse(this.url);
  }
  get facebookUrl() {
    const encodedUrl = encodeURIComponent(this.url);
    return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  }
  get twitterUrl() {
    const encodedUrl = encodeURIComponent(this.url);
    return `http://twitter.com/share?url=${encodedUrl}`;
  }
  get linkedinUrl() {
    const encodedUrl = encodeURIComponent(this.url);
    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
  }
  get wrapperClasses() {
    const wrapperClass = this.wrapperClass || '';
    return `axwp-share__wrapper ${wrapperClass}`;
  }
  get copyTooltipText() {
    return this.tooltip || 'Link was copied';
  }
  copyToClipboard(event) {
    event.preventDefault();
    const element = event.target;
    const parentEl = element.parentElement;
    navigator.clipboard.writeText(this.url).then(() => {
      if (parentEl) {
        parentEl.classList.add('copied');
        const messageTimeout = setTimeout(() => {
          parentEl.classList.remove('copied');
          clearTimeout(messageTimeout);
        }, 3000);
      }
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Share, {
  publicProps: {
    url: {
      config: 0
    },
    title: {
      config: 0
    },
    wrapperClass: {
      config: 0
    },
    tooltip: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Share, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;